import React from 'react';

import { UserPermissions } from '@/features/permissions';
import { Pages } from '@/pages';
import type { AppRouteObject } from '@/routeTypes';

const Information = React.lazy(
  () => import('@/pages/BuildingProfileDetails/views/Information'),
);

const MeteringNodesList = React.lazy(
  () => import('@/pages/BuildingProfileDetails/views/MeteringNodesList'),
);
const Subscribers = React.lazy(
  () => import('@/pages/BuildingProfileDetails/views/Subscribers'),
);
const Documents = React.lazy(
  () => import('@/pages/BuildingProfileDetails/views/Documents'),
);

const DocumentsAndActs = React.lazy(
  () => import('@/pages/BuildingProfileDetails/views/DocumentsAndActs'),
);

const Consumption = React.lazy(
  () => import('@/pages/BuildingProfileIndicators'),
);

// The index tab is not guarded here: BuildingProfileDetails opens the first allowed tab instead.
export const buildingProfileDetailsRoutes: AppRouteObject[] = [
  {
    index: true,
    element: <Information />,
  },
  {
    path: Pages.METERING_NODE,
    element: <MeteringNodesList />,
    handle: { permissions: UserPermissions.BuildingProfilesMeteringNodeRead },
  },
  {
    path: Pages.DOCUMENTS_AND_ACTS,
    element: <DocumentsAndActs />,
    handle: { permissions: UserPermissions.BuildingProfilesActsRead },
  },
  {
    path: Pages.CONSUMPTION,
    element: <Consumption />,
    handle: { permissions: UserPermissions.BuildingProfilesConsumptionRead },
  },
  {
    path: 'subscribers',
    element: <Subscribers />,
    handle: { permissions: UserPermissions.BuildingProfilesSubscribersRead },
  },
  {
    path: Pages.DOCUMENTS_AND_FILES,
    element: <Documents />,
    handle: {
      permissions: UserPermissions.BuildingProfilesDocumentsAndFilesRead,
    },
  },
];
